import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

const Button = forwardRef(({
  isLoading, isDisabled, children, className, ...rest
}, ref) => {
  function getContent() {
    if (isLoading) {
      return (
        <div className={cx('loader')}>
          <span className={cx('bold')}>&bull;</span>
          <span className={cx('bold')}>&bull;</span>
          <span className={cx('bold')}>&bull;</span>
        </div>
      );
    }
    return children;
  }
  return (
    <button type="button" className={cx('button', className)} disabled={isDisabled || isLoading} ref={ref} {...rest}>
      {getContent()}
    </button>
  );
});
export default Button;
Button.propTypes = {
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  className: PropTypes.string,
};
Button.defaultProps = {
  isLoading: false,
  isDisabled: false,
  className: null,
};
